document.addEventListener('DOMContentLoaded', function() {
  // アコーディオンのボタン要素を取得
  const accordionButtons = document.querySelectorAll('.accordion-button');

  accordionButtons.forEach(button => {
    button.addEventListener('click', function() {
      const content = this.nextElementSibling;  // ボタンの直後のコンテンツを取得
      const icon = this.querySelector('.accordion-icon');  // ボタン内のアイコンを取得

      // コンテンツが表示されていなければ表示し、表示されていれば非表示にする
      if (content.style.display === "block") {
        content.style.display = "none";
        icon.textContent = '+';  // アイコンを「+」に変更
      } else {
        content.style.display = "block";
        icon.textContent = '-';  // アイコンを「-」に変更
      }
    });
  });
});
